import { render, staticRenderFns } from "./DatosPadreHistoriaNino.vue?vue&type=template&id=3cd0a084&scoped=true"
import script from "./DatosPadreHistoriaNino.vue?vue&type=script&lang=js"
export * from "./DatosPadreHistoriaNino.vue?vue&type=script&lang=js"
import style0 from "./DatosPadreHistoriaNino.vue?vue&type=style&index=0&id=3cd0a084&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3cd0a084",
  null
  
)

export default component.exports